













































































import VueOptions from '@utils/VueOptions'
import UiList from '@superUI/List/List'
import LoadingIndicator from '@components/LoadingIndicator'

settings = 
  name: "SupplierOrgSelector"
  components: { UiList, LoadingIndicator }
  resources:
    supplierSelector:
      # resourceName: 'activation'
      slug: ':resourcePath'
  vue:
    props: ['resourcePath', 'hiSupplierSelected', 'multi', 'hiMultiSupplierSelected']
    data: ->
      selectedTopSupplierId: null
      selectedSubSupplierId: null
      topSupplierSearch: ''
      subSupplierSearch: ''
      multiSelectedSubSuppliers: []

      suppliers: []
      supplier_sub_orgs: []
    
    mounted: ->
      @fetchSuppliers()
      
    methods:
      hiSelectTopSupplier: (supplierId) ->
        @selectedTopSupplierId = supplierId
        @fetchSuppliers()

      hiSelectSupplier: (supplier, topSupplier) ->
        if !@multi
          @hiSupplierSelected(supplier)
          return

        if topSupplier
          element = document.querySelector('.topSupplierItem')
          supplier.topSupplier = true
        else
          element = [...document.querySelectorAll('.subSupplierList')].find((el) ->
                    el.getAttribute('id') == supplier.id)

        element.style.display = 'none'
        @multiSelectedSubSuppliers.push(supplier)

      hiUnselectSupplier: (selectedSupplier) ->
        if selectedSupplier.topSupplier
          element = document.querySelector('.topSupplierItem')
        else
          element = [...document.querySelectorAll('.subSupplierList')].find((el) ->
                    el.getAttribute('id') == selectedSupplier.id)

        element.removeAttribute 'style'

        @multiSelectedSubSuppliers = @multiSelectedSubSuppliers.filter(
          (supplier) -> supplier.id != selectedSupplier.id
        )

      hiBack: ->
        if @selectedSupplierId
          @selectedSubSupplierId = null
          @selectedSupplierId = null
        else
          @selectedSubSupplierId = null
          @selectedTopSupplierId = null

        @multiSelectedSubSuppliers = []

        @fetchSuppliers()

      fetchSuppliers: (q = '') ->
        ctx = this
        params = {}
        params.page = 1
        params.q = q
        params.supplier_id = @selectedTopSupplierId

        clearTimeout(@searchTimeout)
        @searchTimeout = setTimeout(() ->
          ctx.fetchWithoutStoring(ctx.resourcePath, params).then((result) ->
            if ctx.selectedTopSupplierId
              ctx.supplier_sub_orgs = result
            else
              ctx.suppliers = result
          )
        , 500)
      
      getTopSupplier: ->
        ctx = this
        @suppliers.find((supplier) -> supplier.id == ctx.selectedTopSupplierId)

    watch:
      topSupplierSearch: (value) ->
        @fetchSuppliers(value)
      
      subSupplierSearch: (value) ->
        @fetchSuppliers(value)

export default VueOptions.vue settings
